module.exports = __webpack_public_path__ + "./data/faqs.parent.primary.json";